<template>
    <v-row justify="center" class="text-center">

        <v-col cols="12" class="pa-0 ma-0">
            <h1>{{header.title}}</h1>
        </v-col>
        <v-col cols="12" class="pa-0 ma-0">
            <p class="pa-0 ma-0">{{header.subtitle}}</p>
        </v-col>
        <v-col cols="9">
            <p v-if="$i18n.locale === 'it'" class="pa-0 ma-0">
                {{header.descriptionITA}}
            </p>
            <p v-else class="pa-0 ma-0">
                {{header.descriptionENG}}
            </p>
        </v-col>

    </v-row>
</template>

<script>
    export default {
        name: "HeaderLookbook",
        props: ["header"],
    }
</script>

<style scoped>

</style>